import { ManagerApproval } from '../auth/ManagerApproval';
import type { PendingApproval } from './useApprovalFlow';

/**
 * The manager's staff code and password for one pending approval. `approve` asks the backend for the single-use
 * approval (POST /api/v1/identity/approvals) and returns its id; `describeError` turns a failure into a message.
 */
export function ApprovalPrompt({
  pending,
  approve,
  describeError,
}: {
  pending: PendingApproval | undefined;
  approve(target: PendingApproval['target'], staffCode: string, password: string): Promise<string>;
  describeError(error: unknown): string;
}) {
  if (!pending) return null;
  return (
    <ManagerApproval
      open
      summary={pending.target.summary}
      onCancel={pending.cancel}
      onSubmit={async (staffCode, password) => {
        try {
          await pending.retry(await approve(pending.target, staffCode, password));
          return undefined;
        } catch (error) {
          return describeError(error);
        }
      }}
    />
  );
}
